<template>
	<div>
		<label class="w-100" style="padding-top: 1rem">
			<label class="mb-2" style="color:#b4bebf" v-if="label!=''">
				{{label}}
				<span v-if="error" class="text-danger">
					( {{error_text}} )
				</span>
			</label>
			<div
				id="customInput"
				class="form-Control pointer"
				:class="textClass"
				:style="'background-image:url('+require('../../assets/img/add.png')+')'"
				style="background-color: #f5fafd; border: 1px solid #e5ebeb; color: #219580; border-radius:10px; background-repeat: no-repeat; background-size: 35px; background-position: 10px center;"
				@click="show = true"
			>
				{{ (value=='' || value==null)? label : value }}
			</div>
			<input
				type="file"
				id="files"
				class="d-none"
				accept="application/pdf, image/gif, image/jpeg, image/png"
				name="files"
				@change="onFileChange"
				v-if="inputCheck"
			/>
		</label>
		<div
			class="border border-15 bg p-2 text-success mb-1"
			style="
			min-width: 150px;
			max-width: 100%;
			width: fit-content;
			display: flex;
			align-content: flex-start;
			justify-content: center;
			align-items: center;
			"
			v-for="(f, i) in files"
			:key="i"
		>
			<span
				class="pointer "
				@click="(e)=>{ rtr(f.fileUpload); }"
			>
				<i class="fa fa-download"></i>
				{{ f.fileName }}
			</span>
			&nbsp;
			&nbsp;
			&nbsp;
			<btn
				text="حذف"
				type="white text-danger"
				imgSize="30"
				textClass="p-0"
				@clickMe="rmv(i)"
			/>
		</div>
	</div>
</template>

	<script>
		import btn from  "../../UI/button/btn.vue";
		export default {
			name: 'previewImage',
			data(){
				return {
					inputCheck: true,
				}
			},
			components: {
				btn,
			},
			props: {
				label: {
					type: String,
					default: "label",
				},
				value: {
					type: String,
					default: "",
				},
				files:{
					default: []
				},
				inputFile: {
					default: []
				},
				error: {
					default: true
				},
				error_text: {
					type: String,
					default: ""
				}
			},
			mounted(){

			},
			methods:{
				rmv(index){
					this.files.splice(index, 1);
					this.$emit('removeFile', this.files);
				},
				//____________________________________________________________________
				rtr(fileUpload){
					window.open(window.imgurl + fileUpload);
				},
				//______________________________________________________________________
				onFileChange(e, THIS = this){
					this.$emit('chengeFile', e.target.files);
					this.inputCheck = false;
					setTimeout(()=>{
						THIS.inputCheck = true;
					}, 10);
				},
				uploadImages(e, THIS = this) {
					let image_id = Math.floor(Math.random() * (1000000 - 1000 + 1) + 1000);
					let name = "image_" + image_id;
					let imageData = null;
					let context = null;
					let maxWidth = 1024;
					let maxHeigt = 768;
					let width = maxWidth;
					let height = maxHeigt;
					var vm = this;
					let files = e.target.files;
					vm.imageIndex = 0;

					let formData = new FormData();
					for (let i = 0; i < files.length; i++) {
						let reader = new FileReader();
						let file = files[i];
						if (!file.type.match('image')) continue;
						if (file) {
							var img = document.createElement("img");
							var canvas = $("<canvas/>").get(0);
							reader.onload = function (e) {
								img.src = e.target.result;

							};
							reader.readAsDataURL(file);
							img.onload = function () {
								// Draw
								context = canvas.getContext('2d');
								context.drawImage(img, 0, 0);
								if (img.width > maxWidth || img.height > maxHeigt) {
									width = maxWidth;
									height = maxHeigt;

									if (img.width > maxWidth) {
										width = maxWidth;
										var ration = maxWidth / img.width;
										height = Math.round(img.height * ration);
									}

									if (img.height > maxHeigt) {
										height = maxHeigt;
										var ration = maxHeigt / img.height;
										width = Math.round(img.width * ration);
									}
								} else {
									width = img.width;
									height = img.height;
								}
								canvas.width = width;
								canvas.height = height;

								context.drawImage(img, 0, 0, width, height);
								imageData = canvas.toDataURL('image/jpeg');
								imageData.replace('data:image/jpeg;base64,', '');

								let blobToFile = vm.dataURItoBlob(imageData);
								const cfile = new File(
									[blobToFile], name + ".jpg",
									{type: "image/jpeg", lastModified: Date.now()}
								);
								formData.append('ad_image', cfile);
								// upload to server with axios
								vm.$emit('chengeFile', cfile);
								vm.inputCheck = false;
								setTimeout(()=>{
									THIS.inputCheck = true;
								}, 10);
							}
						}
					}
				},
				dataURItoBlob(dataURI) {
					// convert base64 to raw binary data held in a string
					var byteString = atob(dataURI.split(',')[1]);
					// separate out the mime component
					var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
					// write the bytes of the string to an ArrayBuffer
					var arrayBuffer = new ArrayBuffer(byteString.length);
					var _ia = new Uint8Array(arrayBuffer);
					for (var i = 0; i < byteString.length; i++) {
						_ia[i] = byteString.charCodeAt(i);
					}
					var dataView = new DataView(arrayBuffer);
					var blob = new Blob([dataView], {type: mimeString});
					return blob;
				},
				//______________________________________________________________________
			}
		}
	</script>
<style>

</style>
